module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "touchList",
    attrs: {
      "id": "touchList"
    }
  }, [_c('head-top', {
    attrs: {
      "appName": _vm.appName,
      "attention": _vm.attention,
      "bg": _vm.topicInfo.imgUrl,
      "sid": _vm.sid,
      "themeColor": _vm.themeColor,
      "topicID": _vm.topicID,
      "topicInfo": _vm.topicInfo,
      "uid": _vm.uid,
      "shareData": _vm.shareData
    },
    on: {
      "topicToApp": _vm.topicToApp
    }
  }), _vm._v(" "), _c('list', {
    attrs: {
      "sid": _vm.sid,
      "themeColor": _vm.themeColor,
      "topicID": _vm.topicID
    },
    on: {
      "showPopover": _vm.showPopover,
      "topicShowSwiper": _vm.topicShowSwiper
    }
  }), _vm._v(" "), _c('bottomOpenApp', {
    attrs: {
      "sid": _vm.sid,
      "themeColor": _vm.themeColor
    },
    on: {
      "topicToApp": _vm.topicToApp
    }
  }), _vm._v(" "), (_vm.popoverShow == 0) ? _c('Popover', {
    attrs: {
      "appName": _vm.appName,
      "istopiclist": 1
    },
    on: {
      "showPopover": _vm.showPopover,
      "topicToApp": _vm.topicToApp
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6318253d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/topicColumn.vue
// module id = 324
// module chunks = 1